import { ThemeProvider } from '@emotion/react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { createTheme } from '@mui/material/styles';
import { NormalButton } from 'components/atoms/Button';
import RewardsSidebarAvm from 'components/organisms/Sidebar/RewardsSidebarAvm';
import RewardsSidebarCreatorFund from 'components/organisms/Sidebar/RewardsSidebarCreatorFund';
import RewardsSidebarJackpot from 'components/organisms/Sidebar/RewardsSidebarJackpot';
import * as React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import AvmBody from 'views/DesktopViews/RewardsPage/AvmBody';
import CreatorFundBody from 'views/DesktopViews/RewardsPage/CreatorFundBody';
import JackpotBody from 'views/DesktopViews/RewardsPage/JackpotBody';
import useStyles from './RewardsBody.styles';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const TabsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(255,255,255,0.1)',
  padding: '5px',
  borderRadius: '20px',
  width: 'fit-content',
}));

const RewardBody = () => {
  const [currentTab, setCurrentTab] = React.useState<string>('AVM');
  const classes = useStyles();

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ThemeProvider theme={colortheme}>
        <Box className={classes.body}>
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                padding: '1rem 3rem',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <TabsWrapper>
                <Box
                  style={{
                    display: 'flex',
                    gap: '5px',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                  }}
                >
                  <NormalButton
                    color={`${currentTab === 'AVM' ? 'yellow' : 'transparent'}`}
                    style={{ width: '150px' }}
                    onClick={() => setCurrentTab('AVM')}
                  >
                    AVM
                  </NormalButton>
                  <NormalButton
                    color={`${
                      currentTab === 'CreatorFund' ? 'yellow' : 'transparent'
                    }`}
                    style={{ width: '150px' }}
                    onClick={() => setCurrentTab('CreatorFund')}
                  >
                    Creator Fund
                  </NormalButton>
                  <NormalButton
                    color={`${
                      currentTab === 'Jackpot' ? 'yellow' : 'transparent'
                    }`}
                    style={{ width: '150px' }}
                    onClick={() => setCurrentTab('Jackpot')}
                  >
                    Jackpot
                  </NormalButton>
                </Box>
              </TabsWrapper>
            </Grid>

            <Box>
              <Grid container xs={12}>
                <Grid item xs={12} lg={3}>
                  {currentTab === 'AVM' ? (
                    <RewardsSidebarAvm />
                  ) : currentTab === 'CreatorFund' ? (
                    <RewardsSidebarCreatorFund />
                  ) : currentTab === 'Jackpot' ? (
                    <RewardsSidebarJackpot />
                  ) : (
                    <></>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  lg={9}
                  sx={{
                    padding: '1rem 5rem',
                    gap: '6px',
                    boxSizing: 'border-box',
                    [colortheme.breakpoints.down('md')]: {
                      padding: '0',
                    },
                  }}
                >
                  {currentTab === 'AVM' ? (
                    <AvmBody />
                  ) : currentTab === 'CreatorFund' ? (
                    <CreatorFundBody />
                  ) : currentTab === 'Jackpot' ? (
                    <JackpotBody />
                  ) : (
                    <></>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Box>
      </ThemeProvider>
    </div>
  );
};

export default RewardBody;
